
class ContactUs {
    constructor() {
      
        const observer = new MutationObserver((mutations, observer) => {
            var targetElement = document.querySelector('[data-forms-id="forms-root-397750"] #app-embed');
            if (targetElement) {  
              
                // Disconnect the observer once the element is found
                observer.disconnect();
                this._applyCss(targetElement);
                this._trackFormStart(targetElement);
            }
        });  
        // Observe changes in the entire document
        observer.observe(document.body, { childList: true, subtree: true });
    }

    _applyCss(targetElement){
        const shadowRoot = targetElement.shadowRoot;
        const style = document.createElement('style');
        style.textContent = `
            ._container_3eyaa_70 {
                display: block !important;
            }
            ._inline_stahb_47 ._formContainer_stahb_30 {
                max-width: 650px !important;
            }
            form ._formFieldContainer_1ydxd_5 > label { 
                position: absolute;
                top: 0 !important;
                left: 0;
                z-index: 2;
                font-size: 14px;
                padding: 11.5px 20px;
                color: #000000;
                line-height: 21px;
                overflow: hidden;
                text-align: start;
                text-overflow: ellipsis;
                white-space: nowrap;
                pointer-events: none;
                border: 1px solid transparent;
                -webkit-transform-origin: 0 0;
                transform-origin: 0 0;
                transition: font-size .15s ease-in-out, transform .15s ease-in-out;
            }
            form ._formFieldContainer_1ydxd_5 > input,
            form ._formPhoneInputContainer_1ym3p_6 ._selectToggle_1yit2_25,
            form ._formFieldContainer_1ydxd_5 ._textArea_17mgw_1 {
                display: block;
                padding: 11.5px 20px;
                font-family: Open Sans;
                font-size: 14px;
                font-weight: 400;
                line-height: 21px;
                color: #000000;
                background-color: #ffffff;
                background-clip: padding-box;
                border: 1px solid #b3b3b3;
                border-radius: 5px;
                -webkit-appearance: none;
                -moz-appearance: none;
                appearance: none;
                box-shadow: none;
                transition: border-color .15s ease-in-out;
            }
            form ._formFieldContainer_1ydxd_5 > input:focus, 
            form ._formFieldContainer_1ydxd_5 > input:not(:placeholder-shown),
            form ._formFieldContainer_1ydxd_5 ._textArea_17mgw_1:focus, 
            form ._formFieldContainer_1ydxd_5 ._textArea_17mgw_1:not(:placeholder-shown) {
                padding-top: 19px;
                padding-bottom: 4px;
            }
            ._selectContainer_1yit2_6 ._selectToggle_1yit2_25 ._selectToggleText_1yit2_25 {
                width: 25px !important;
                height: 25px !important;
            }
             ._selectContainer_1yit2_6 ._selectToggle_1yit2_25 ._selectToggleText_1yit2_25 {
                width: 100% !important;
                height: 100% !important;
            }
            ._selectContainer_1yit2_6 ._selectToggle_1yit2_25 ._arrowDownIcon_1yit2_19 {
                margin: 0 !important;
            }
            ._formPhoneInputContainer_1ym3p_6 ._selectContainer_1yit2_6 ._selectToggle_1yit2_25 {
                display: flex !important;
                align-items: center !important;
            }
            form [type="submit"] {
                color: #000000 !important;
                font-weight: 700 !important;
                margin-left: auto !important;
                border-radius: 3px !important;
                width: fit-content !important;
                padding: 17px 35px !important;
                display: inline-block !important;
                font-family: Open Sans !important;
                border: 1px solid #000000 !important;
                background-color: transparent !important;
                transition: all .15s ease-in-out !important;
            }
            form [type="submit"]:hover {
                color: #ffffff !important;
                border-color: #087e45 !important;
                background-color: #087e45 !important;
            }
        `;
        shadowRoot.querySelector("[data-form-root]").appendChild(style);

    }

    _trackFormStart(targetElement) {
        const shadowRoot = targetElement.shadowRoot;
        const form = shadowRoot.querySelector('form');
        let formStarted = false;
        
        if (form) {
            // Track when user starts interacting with the form
            const inputs = form.querySelectorAll('input, textarea, select');
            inputs.forEach(input => {
                input.addEventListener('focus', () => {
                    if (!formStarted) {
                        formStarted = true;
                        window.dataLayer = window.dataLayer || [];
                        console.log('form started')
                        window.dataLayer.push({
                            event: "form_start",
                            form_id: "forms-root-397750",
                            form_name: "Contact Us",
                            form_type: "contact",
                            form_destination: window.location.href
                        });
                    }
                });
            });

            // Track form submission - start observer only after submit button is clicked
            form.addEventListener('submit', () => {
                const submitButton = form.querySelector('[type="submit"]');
                const submitText = submitButton ? submitButton.textContent.trim() : 'Submit';
                
                console.log('form submit attempted');
                
                // Start observer only after submit to watch for success banner
                const successObserver = new MutationObserver((mutations) => {
                    const successBanner = shadowRoot.querySelector('[data-testid="banner-success"]');
                    if (successBanner) {
                        window.dataLayer = window.dataLayer || [];
                        console.log('form submitted successfully');
                        window.dataLayer.push({
                            event: "form_submit",
                            form_id: "forms-root-397750",
                            form_name: "Contact Us",
                            form_type: "contact",
                            form_destination: window.location.href,
                            form_submit_text: submitText
                        });
                        
                        // Disconnect observer after successful submission
                        successObserver.disconnect();
                    }
                });
                
                // Start observing only after submit button is clicked
                successObserver.observe(shadowRoot, { childList: true, subtree: true });
                
                // Auto-disconnect observer after 10 seconds if no success banner appears
                setTimeout(() => {
                    successObserver.disconnect();
                }, 10000);
            });
        }
    }
  }
 
 new ContactUs();
